import { createAsyncThunk } from '@reduxjs/toolkit';
import { type IErrorData, getErrorData } from '../../utils/getErrorData';
import { isError } from '../../utils/typeguards/isError';
import { updateVendorOrderOfferStatus } from '../../api/vendorApi';
import {
  type IVendorOrderItem,
  type VendorOrderOfferStatus
} from '../../types/IVendorOrderResponse';
import { type RootState } from '../store';

/**
 * Общая санка для обновления статуса торгового предложения
 * Может использоваться в разных сторах (vendors, vendor-applications)
 */
export const updateVendorOrderOfferStatusSharedThunk = createAsyncThunk<
  IVendorOrderItem,
  { order_offer_uuid: string; status: VendorOrderOfferStatus },
  { rejectValue: IErrorData; state: RootState }
>(
  'shared/updateVendorOrderOfferStatus',
  async ({ order_offer_uuid, status }, { rejectWithValue, signal }) => {
    try {
      const data = await updateVendorOrderOfferStatus({
        order_offer_uuid,
        status,
        signal
      });

      if (data === 'Abort') {
        return rejectWithValue({ message: 'Запрос был отменен' });
      }

      if (isError(data)) {
        return rejectWithValue(data);
      }

      if (data.response === null) {
        return rejectWithValue({ message: 'Некорректный ответ сервера' });
      }

      return data.response;
    } catch (error) {
      const errorData = getErrorData(error);
      return rejectWithValue(errorData);
    }
  }
);
